import * as React from "react"
import {Box, Typography} from "@mui/material";

import {LabelCountry} from "@components";


export default function retailerColumn() {

    return {
        name: "retailer", label: 'Retailer',
        options: {
            filter: false,
            setCellHeaderProps: () => ({ sx: { minWidth: 180 }}),
            customBodyRowRender: (value, { market, sectionURL, device }) => <Box >
                <LabelCountry label={value} siteUrl={sectionURL} country={market} ellipsis={true} />
                <Box display="flex" flexDirection="column" gap={0}>
                    <Box display="flex" gap={.5}>
                        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: "bold" }}>Device: </Typography>
                        {device}
                    </Box>
                </Box>
            </Box>
        }
    }
}
